import React, { Component } from "react";
import moment from "moment";
import BigCalendar from "react-big-calendar";
import { Col, Row } from "react-bootstrap";
import CalendarForm from "../../forms/days-off/CalendarForm";

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class Calendar extends Component {
	render() {
		return (
    		<div className="crud-page log-hours-page">
    			<div className="container-fluid">
    				<section className="actions">
    					<Row>
    						<Col md={6} sm={6} xs={12}>
    							<h2 className="page-title">Days Off Calendar</h2>
    						</Col>
    					</Row>   
    				</section>
    				<div className="card card-top-border card-log-hours fadeInLoadUp">				 
						<CalendarForm />
    				</div>   
    			</div>
    		</div>
		);
	}
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/pages/days-off/CalendarPage.js